import React from "react";
import {
  InputClearValue,
  InputSuffix,
  TextBox,
} from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { searchIcon, xIcon } from "@progress/kendo-svg-icons";

const SearchTextBox = React.forwardRef((props, ref) => {
  const [localFilterValue, setLocalFilterValue] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    clearSearch: () => {
      setLocalFilterValue("");
    },
  }));

  const handleFilterChange = (e) => {
    setLocalFilterValue(e.target.value);
  };

  const handleFilter = () => {
    props.changeFilterValue(localFilterValue);
  };

  const handleClear = () => {
    setLocalFilterValue("");
    props.changeFilterValue();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilter();
    }
  };

  return (
    <div
      style={{
        width: props.width || "17.5rem",
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
        zIndex: 10,
        ...props.style,
      }}
    >
      <TextBox
        onKeyDown={handleKeyDown}
        value={localFilterValue}
        onChange={handleFilterChange}
        style={{
          height: props.height,
        }}
        placeholder={props.placeholder || "Search here"}
        suffix={() => (
          <>
            <InputClearValue
              className={`bg-light rounded-circle pe-1 d-flex align-items-center justify-content-center ${localFilterValue ? "" : "d-none"
                }`}
              onClick={handleClear}
              aria-label="Clear search"
            >
              <SvgIcon icon={xIcon} />
            </InputClearValue>

            <InputSuffix className="bgprimary">
              <Button
                style={{ width: "40px" }}
                className="h-100 search-button"
                onClick={handleFilter}
                fillMode="flat"
                rounded={null}
                svgIcon={searchIcon}
                aria-label="Execute search"
              />
            </InputSuffix>
          </>
        )}
      />
    </div>
  );
});
export default SearchTextBox;
